import React, { PropsWithChildren, useState } from 'react';
import { LessonCardBody, LessonCardFooter, LessonCardHeader, LessonCardWrapperAnchor, LessonCardWrapperBlock } from './lesson-card.styles';
import { ILessonCardProps } from './lesson-card.models';
import classNames from 'classnames';
import { LockIcon } from './lock.icon';
import { colourString, SkillPercentage } from '@keplerco/core';
import { useNavigate } from 'react-router-dom';
import { AssessmentState } from '../../enums/assessmentState';

function LessonCardComponent(props: PropsWithChildren<ILessonCardProps>): JSX.Element {
  const navigate = useNavigate();
  function LessonCardInner() {
    return (
      <React.Fragment>
        <LessonCardHeader>
          <h6 style={{ display: 'block', margin: 'auto' }} className="subtitle">{props.name}</h6>
        </LessonCardHeader>
        <LessonCardBody>

          <p className="body2">{props.description}</p>

            <div style={{ marginLeft: 'auto', paddingTop: 10 }}>
            <SkillPercentage
              percentage={props.score!}
              notAssessed={props.assessmentState !== AssessmentState.Assessed}
              title={props.assessmentState !== AssessmentState.Assessed ? '' : 'Quiz score'}
            />
          </div>
        </LessonCardBody>

        {!!props.footer && (
          <React.Fragment>
            {!props.disabled ? (
              <LessonCardFooter className={classNames({ borderTop: props.footer.borderTop })} backgroundColour={props.footer.backgroundColour ?? 'cards'} colour={props.footer.colour ?? 'text'}>
                <span className="caption1">{props.footer.text}&nbsp;</span>
                {props.footer.icon}
              </LessonCardFooter>
            ) : (
              <React.Fragment>
                <LessonCardFooter className={classNames({ borderTop: props.footer.borderTop })} backgroundColour={props.disabled ? 'default' : props.footer.backgroundColour ?? 'cards'} colour={props.disabled ? 'black' : props.footer.colour ?? 'contrast-text'}>
                  <span className="caption1" style={{ color: colourString(props.disabled ? 'black' : props.footer.colour ?? 'contrast-text') }}>
                    Lesson locked&nbsp;
                  </span>
                  <LockIcon tone={props.footer.colour ?? 'contrast-text'} size={15} />
                </LessonCardFooter>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  if (props.disabled)
    return (
      <LessonCardWrapperBlock className={classNames({ disabled: true, footer: !!props.footer })}>
        <LessonCardInner />
      </LessonCardWrapperBlock>
    );

  return (
    <LessonCardWrapperAnchor onClick={() => navigate(props.lessonUrl)} className={classNames({ footer: !!props.footer })} target="_blank" rel="noopener noreferrer">
      <LessonCardInner />
    </LessonCardWrapperAnchor>
  );
}

export const LessonCard = React.memo(LessonCardComponent, (previous, next) => {
  if (previous.completed !== next.completed || previous.lessonUrl !== next.lessonUrl || previous.disabled !== next.disabled) return false;
  return true;
});

